<template>
  <v-container style="background-color: #104B94;" class="fill-height" fluid>
    <overlay :value="loading"></overlay>
    <v-container class="d-flex flex-column justify-center align-center fill-height">
      <v-card class="ma-0 ma-md-6 pa-8" width="100%" max-width="400px">
        <v-img class="mb-4" src="@/assets/new_Pawer_Logo.png" height="50" contain></v-img>
        <v-card-text class="ma-0 pa-0">
          <h3 class="text-center mb-2">Verificación en dos pasos</h3>
          <p class="text-body-2 text-center mb-4">
            Ingresa el código de 6 dígitos de tu aplicación de autenticación.
          </p>

          <!-- @submit.prevent is required, not cosmetic: this form has a single
               text field, so the browser performs implicit submission on Enter
               and reloads the page mid-request. The retry then hits the replay
               guard and reports a valid code as invalid. -->
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate">
            <v-text-field
              v-model="code"
              :rules="codeRules"
              label="Código"
              maxlength="11"
              required
              :disabled="loading"
              @keydown.enter.prevent="validate"
            ></v-text-field>

            <v-alert v-if="error" dense type="error">{{ errorMessage }}</v-alert>

            <div class="d-flex justify-center">
              <v-btn
                type="button"
                color="primary"
                class="mt-4"
                rounded
                :loading="loading"
                :disabled="loading"
                @click="validate"
              >Entrar</v-btn>
            </div>

            <p class="text-caption text-center mt-4 mb-0">
              ¿Perdiste tu teléfono? Ingresa uno de tus códigos de recuperación
              y podrás vincular un dispositivo nuevo a continuación.
            </p>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
import Overlay from '../components/Overlay.vue';
import MfaService from '../services/mfa.service';

// Either a 6-digit TOTP code or a recovery code (XXXXX-XXXXX, hyphen optional).
const CODE_PATTERN = /^([0-9]{6}|[A-Za-z2-9]{5}-?[A-Za-z2-9]{5})$/;

export default {
  components: { Overlay },
  data: () => ({
    valid: true,
    loading: false,
    error: false,
    errorMessage: '',
    code: '',
    codeRules: [
      v => !!v || 'El código es requerido',
      v => CODE_PATTERN.test((v || '').trim()) || 'Ingresa un código de 6 dígitos o uno de recuperación'
    ]
  }),
  created() {
    if (!MfaService.getMfaToken()) {
      this.$router.push({ path: '/login' });
    }
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.verify();
      }
    },
    async verify() {
      this.loading = true;
      this.error = false;
      const response = await MfaService.verify(this.code.trim());
      if (response.status === 'ok') {
        // A recovery code gets you back in, but the old device is gone: the
        // backend cleared the registration, so a new one must be scanned now.
        // `/` resolves the admin's default section (router guard, spec 028).
        const path = response.nextStep === 'mfa_setup' ? '/mfa/setup' : '/';
        this.$router.push({ path });
      } else {
        this.code = '';
        this.error = true;
        this.errorMessage = response.code === 'MFA_TOO_MANY_ATTEMPTS'
          ? 'Demasiados intentos fallidos. Espera unos minutos antes de reintentar.'
          : 'El código ingresado no es válido';
      }
      this.loading = false;
    }
  }
};
</script>
